<template>
  <div>
    <input
      type="file"
      name="profile_avatar"
      accept=".png, .jpg, .jpeg"
      ref="file"
      v-on:change="handleFileUpload"
    />

    <b-modal id="modal-lg" title="برش دادن" @ok="Crop" ok-title="ذخیره" cancel-title="لغو">
      <cropper
        class="cropper"
        :src="image"
        :stencil-props="{
		aspectRatio: 12/12
	}"
        ref="cropper"
      ></cropper>
    </b-modal>

    <!--     
    <b-button @click="Crop">Crop</b-button>-->
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import httpHelper from "../helpers/httpHelper";

export default {
  data() {
    return {
      image: null,
      fileitem: null,
      error: "",
      validated: true
    };
  },
  props: ["fileUploaded"],
  methods: {
    handleFileUpload(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
        this.$bvModal.show("modal-lg");
      }
    },
    Crop(event) {
      event.preventDefault();
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        const form = new FormData();
        canvas.toBlob(blob => {
          httpHelper.setAuth();
          httpHelper.UploadFile(blob).then(res => {
            if (res.success) {
              this.$bvModal.hide("modal-lg");
              this.validated = true;
              this.$emit("input", res.result);
              if (this.fileUploaded != null) {
                this.fileUploaded();
              }
            } else {
              this.error = res.error;
              this.validated = false;
            }
          });
        }, "image/jpeg");
      }
    }
  },
  components: {
    Cropper
  }
};
</script>